"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _DOMAIN = 'draft-group-filter/';
exports.default = {
  INIT: _DOMAIN + 'INIT',
  CONFIRM: _DOMAIN + 'CONFIRM',
  RESET: _DOMAIN + 'RESET',
  SELECT: _DOMAIN + 'SELECT',
  NAVIGATE: _DOMAIN + 'NAVIGATE',
  CLEAR: _DOMAIN + 'CLEAR'
};